"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { Page } from "@/helpers/Types";
import { TimeWindow, TIME_WINDOW_MS } from "@/types/boosted-drops.types";
interface UseBoostedDropsProps {
  readonly limit?: number;
  readonly timeWindow?: TimeWindow;
}
const DEFAULT_LIMIT = 10;
const STALE_TIME = 60000; // 1 minute
const REFETCH_INTERVAL = 30000; // 30 seconds

export function useBoostedDrops(t0) {
  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    limit: t2,
    timeWindow: t3
  } = t1;
  const limit = t2 === undefined ? DEFAULT_LIMIT : t2;
  const timeWindow = t3 === undefined ? TimeWindow.DAY : t3;
  let t4;
  if ($[2] !== limit || $[3] !== timeWindow) {
    t4 = {
      queryKey: [QueryKey.BOOSTED_DROPS, {
        global: true,
        limit,
        timeWindow
      }],
      queryFn: async () => {
        const countOnlyBoostsAfter = Date.now() - TIME_WINDOW_MS[timeWindow];
        const response = await commonApiFetch({
          endpoint: "boosted-drops",
          params: {
            sort: "boosts",
            sort_direction: "DESC",
            page_size: limit.toString(),
            count_only_boosts_after: countOnlyBoostsAfter.toString()
          }
        });
        return response.data;
      },
      staleTime: STALE_TIME,
      refetchInterval: REFETCH_INTERVAL,
      retry: 2,
      retryDelay: _temp
    };
    $[2] = limit;
    $[3] = timeWindow;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return useQuery(t4);
}
function _temp(attemptIndex) {
  return attemptIndex * 1000;
}